<template>
  <!--:style="{top:node.pageY+'px',right:node.pageX+'px'}"-->
  <div>
    <ul class="pure-menu-list sub-nav" :style="node.style" v-show="node.isChildren">
      <li class="nav-item" v-for="(navItem, key) in node.children" :key="key">
        <el-tooltip slot="reference" :content="navItem.NODENAME" placement="top" effect="light">
          <a
            @mouseenter="mouseenter(navItem, $event)"
            @contextmenu.prevent="liContextmenu(navItem)"
            @click="openBlank(navItem)"
            :style="{width:(navItem.NODETYPE == 3 || navItem.NODETYPE == 2)?'160px':'188px'}"
            style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display: inline-block;"
          >
            <svg class="icon alSvgIcon" aria-hidden="true">
              <use :xlink:href="'#'+getTaskTypeIcon(navItem)" />
            </svg>
            {{navItem.NODENAME}}
            <collect-node :node="navItem"></collect-node>
          </a>
        </el-tooltip>
        <i
          v-if="navItem.NODETYPE == 3 || navItem.NODETYPE == 2"
          style="position: relative;top: -14px;color: #333;font-weight: bolder;"
          class="el-icon-arrow-right"
        ></i>
      </li>
    </ul>
  </div>
</template>

<script>
import { AddTaskViewHistory } from "@/api/modules/basicData/task";
import folderApi from "@/api/modules/basicData/folder";
import Linq from "linq";
import { mapState } from "vuex";
export default {
  name: "CollectNode",
  data() {
    return {
      currentNode: {}
    };
  },
  props: {
    node: {
      default() {
        return {};
      }
    }
  },
  computed: {
    ...mapState({
      userId: state => state.task.userId,
      Person: state => state.folder.Person
    })
  },
  methods: {
    liContextmenu(row) {
      this.$emit("liContextmenu", row);
    },
    getTaskTypeIcon(row) {
      let filter = this.$options.filters["taskStateIcon"];
      return row.NODETYPE == 3? "icon-wenjianjia": row.NODETYPE == 2
        ? "icon-zul"
        : filter(row.RELATIONSTATE);
    },
    mouseenter(data, $event) {
      console.log('srcElement',$event.srcElement)
      console.log($event.target.getBoundingClientRect())
      let client = $event.target.getBoundingClientRect();
      data.pageY = $event.pageY;
      data.pageX = data.Level * 200;
      this.currentNode.isChildren = false;
      if (!data.isLoad && (data.NODETYPE == 3 || data.NODETYPE == 2)) {
        let paras = {
          NodeId: data.NODEID,
          IsRoot: false,
          PermissionType: 0
        };
        paras.Person = this.Person;
        folderApi.GetTaskTreePathList(paras).then(res => {
          if (res && res.length > 0) {
            res = Linq.from(res)
              .orderByDescending(item => item.CREATETIME)
              .toArray();
            res.forEach(item => {
              item.isLeaf = item.CHILDRENCOUNT == 0;
              item.PermissionType = paras.PermissionType;
              item.Level = data.Level + 1;
              item.isChildren = false;
            });
            data.children = res;
            data.style = this.getPagePosition(
              client.top,
              $event.pageY,
              data
            );
            data.isLoad = true;
            data.isChildren = true;
            this.currentNode = data;
          }
        });
      } else if (data.NODETYPE == 3 || data.NODETYPE == 2) {
        data.isChildren = true;
        this.currentNode = data;
        data.style = this.getPagePosition(
          client.top,
          $event.pageY,
          data
        );
      } else {
        if (data.NODETYPE != 0) {
          data.isChildren = true;
          data.style = this.getPagePosition(
            client.top,
            $event.pageY,
            data
          );
        }
      }
    },
    openBlank(row) {
      if (row.NODETYPE !== 0) {
        return false;
      }
      let pars = {
        TaskId: row.RELATIONID,
        Person: this.Person
      };
      AddTaskViewHistory(pars).then(pmevent => {});
      let hostUrl = location.href.split("#")[0];
      if (typeof jsObj == "undefined") {
        let routeUrl = this.$router.resolve({
          path: "/task-detailspage",
          query: {
            taskid: row.RELATIONID
          }
        });
        window.open(routeUrl.href);
      } else {
        let routeUrl = this.$router.resolve({
          path: "/task-detailspage",
          query: {
            taskid: row.RELATIONID,
            code: this.code
          }
        });
        jsObj.Invoke("OpenWebBrowser", hostUrl + routeUrl.href);
      }
    },
    getPagePosition(pageX, pageY, data) {
      let postion = {};
      let pageHeight = document.body.offsetHeight;
      let pageWidth = document.body.offsetWidth;
      // alert(pageHeight);
      // alert(pageY+data.children.length*40);
      if (pageHeight < pageX + data.children.length * 40) {
        postion.bottom = "0px";
      } else {
        postion.top = pageX + "px";
      }

      if (pageWidth < (data.Level + 1) * 200) {
        postion.left = "0px";
      } else {
        postion.right = data.Level * 200 + "px";
      }
      return postion;
    }
  }
};
</script>

<style lang="less" scoped>
.sub-nav {
  box-sizing: border-box;
  background: rgb(236, 245, 255);
  width: 200px;
  transition: opacity 0.3s;
  border: 1px solid #eee;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 4px, rgba(0, 0, 0, 0.04) 0px 0px 6px;
  position: fixed;
  text-align: left;
  z-index: 100;
  li {
    list-style: none;
    padding-left: 10px;
    height: 40px;
  }
}
.nav-item {
  &:hover,
  &.active {
    color: #409eff;
    background: #909399;
  }
  a {
    font-size: 16px;
    color: #333;
    line-height: 40px;
    height: 40px;
    margin: 0;
    padding: 0;
    text-decoration: none;
    display: block;
    cursor: pointer;
    position: relative;
    transition: 0.15s ease-out;
    font-weight: bold;
    // &:hover,
    // &.active {
    //   color: #409eff;
    // }
    .alSvgIcon {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      fill: currentColor;
      overflow: hidden;
    }
  }

  // .nav-item {
  //   a {
  //     display: block;
  //     height: 40px;
  //     color: #444;
  //     line-height: 40px;
  //     font-size: 14px;
  //     overflow: hidden;
  //     white-space: nowrap;
  //     text-overflow: ellipsis;
  //     font-weight: 540;
  //     &:hover,
  //     &.active {
  //       color: #409eff;
  //     }
  //   }
  // }

  &.sponsors {
    & > .sub-nav {
      margin-top: -10px;
    }

    & > a {
      color: #777;
      font-weight: 300;
      font-size: 14px;
    }

    .nav-item {
      display: inline-block;

      a {
        height: auto;
        display: inline-block;
        vertical-align: middle;
        margin: 8px 12px 12px 0;

        img {
          width: 42px;
        }
      }

      &:first-child a img {
        width: 36px;
      }
    }
  }
}
</style>